import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import './styles/element/index.scss'
import './styles/im-theme.scss'
import { initTheme } from './utils/imTheme'
// import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

const app = createApp(App)
initTheme()
app.mixin({
  data(){
    return {
      
    }
  },
  methods:{
    checkPermi(value){
      if (value && value instanceof Array && value.length > 0) {
        const permissions = store.getters && store.getters.permissions
        const permissionDatas = value
        const all_permission = "*:*:*";
        const hasPermission = permissions&&permissions.some(permission => {
          return all_permission === permission || permissionDatas.includes(permission)
        })
        if (!hasPermission) {
          return false
        }
        return true
      } else {
        console.error(`need roles! Like checkPermi="['system:user:add','system:user:edit']"`)
        return false
      }
    }
  }
})

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}


app.use(store)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.use(VueViewer, {
    defaultOptions: {}
})
app.mount('#app')
